import React from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {makeStyles} from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import * as GameActions from '../redux/actions/game_actions';

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  word: {
    height: '30px',
    padding: '3px',
  },
  letterButton: {
    marginRight: '2px',
  },
}));

export default function ScoreBox() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const word = useSelector((state) => state.game.word);
  useSelector((state) => state.game.text);
  const score = useSelector((state) => state.game.score);
  const isValid = useSelector((state) => state.game.isValid);

  return (
    <Paper>
      <Box className={classes.word}>
        <Typography>
          {word.map((letter, index) => (
            <Button
              key={`word-${index}`}
              size="small"
              className={classes.letterButton}
              onClick={() => dispatch(GameActions.restore(index, letter))}
              color={isValid ? 'primary' : 'secondary'}
              variant="contained">
              {letter.val.val}
            </Button>
          ))}
        </Typography>
      </Box>
      <Box mt={2}>
        <Typography variant="h6">
          <Grid container justify="center" className={classes.root} spacing={1}>
            <Grid item xs={2}>
              <Button variant="contained" disabled>
                {isValid ? score : 0}
              </Button>
            </Grid>
            <Grid item xs={2}>
              <Button variant="contained" onClick={() => dispatch(GameActions.clear())} color="secondary">Clear</Button>
            </Grid>
            <Grid item xs={2}>
              <Button variant="contained" onClick={() => dispatch(GameActions.go())} disabled={!isValid} color="primary">Go!</Button>
            </Grid>
          </Grid>
        </Typography>
      </Box>
    </Paper>
  );
};
